import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ButtonStyled, ErrorHeading, ErrorImg, ErrorSection, ErrorText } from './Error.styles';

export const Error: FC = () => {
	const { t } = useTranslation();

	return (
		<ErrorSection>
			<ErrorImg src='https://cdn.dodostatic.net/static/marketplace/error' />
			<ErrorHeading>{t(`Marketplace_Error_Heading`)}</ErrorHeading>
			<ErrorText>
				{t(`Marketplace_Error_Text`)}
				<a href='mailto:support@dodopizza.com'>support@dodopizza.com</a>
			</ErrorText>
			<a href='/'>
				<ButtonStyled type='primary'>{t(`Marketplace_Error_Back_To_Home`)}</ButtonStyled>
			</a>
		</ErrorSection>
	);
};
